import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MorningIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const MorningIcon: React.FC<MorningIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path d="M16 8.6611H14.2222V7.1611H16V8.6611Z" fill={colors[color]} />
      <Path
        d="M8.75 0.799988V2.57777H7.25V0.799988L8.75 0.799988Z"
        fill={colors[color]}
      />
      <Path
        d="M0 8.6611H1.77778L1.77778 7.1611H6.55664e-08L0 8.6611Z"
        fill={colors[color]}
      />
      <Path
        d="M3.06993 4.93014L1.81285 3.67307L2.87351 2.61241L4.13059 3.86948L3.06993 4.93014Z"
        fill={colors[color]}
      />
      <Path
        d="M13.1269 2.61327L11.8698 3.87035L12.9305 4.93101L14.1876 3.67393L13.1269 2.61327Z"
        fill={colors[color]}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.888889 10.7167H3.17084C2.93516 10.1233 2.80556 9.47642 2.80556 8.79996C2.80556 5.93115 5.13119 3.60552 8 3.60552C10.8688 3.60552 13.1944 5.93115 13.1944 8.79996C13.1944 9.47642 13.0648 10.1233 12.8292 10.7167H15.1111V12.2167H4.44444L4.06954 12.2167H0.888889L0.888889 10.7167ZM4.84088 10.7167C4.50108 10.1581 4.30556 9.50262 4.30556 8.79996C4.30556 6.75958 5.95961 5.10552 8 5.10552C10.0404 5.10552 11.6944 6.75958 11.6944 8.79996C11.6944 9.50262 11.4989 10.1581 11.1591 10.7167H4.84088ZM8 7.10552C6.78804 7.10552 5.80556 8.08801 5.80556 9.29996C5.80556 9.65852 5.89373 9.99702 6.05096 10.2956C6.0528 10.299 6.05465 10.3024 6.05651 10.3058C6.05943 10.3109 6.06237 10.316 6.06533 10.3211C6.28213 10.6167 6.56796 10.8571 6.89897 11.0167H9.10103C9.43204 10.8571 9.71787 10.6167 9.93467 10.3211C9.93763 10.316 9.94057 10.3109 9.94349 10.3058C9.94535 10.3024 9.9472 10.299 9.94904 10.2956C10.1063 9.99702 10.1944 9.65852 10.1944 9.29996C10.1944 8.08801 9.21196 7.10552 8 7.10552Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

MorningIcon.displayName = 'MorningIcon';
export { MorningIcon };
